class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => { this.onSubmitHandler(event) }, 800);
    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const loadingOverlays = document.querySelectorAll(`#LoadingOverlay-${section.section}`);
      const filterDataUrl = (element) => element.url === url;
      [...loadingOverlays].forEach((overlay) => overlay.enableLoading());
      FacetFiltersForm.filterData.some(filterDataUrl) ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) : FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        document.dispatchEvent(new CustomEvent('shopify:filter:change'), { bubbles: true });
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormDrawer .js-filter');
    const facetDetailsElementsCurrent = document.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormDrawer .js-filter');
    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsCurrent).forEach((currentElement) => {
      if (!Array.from(facetDetailsElements).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? (element.dataset.index === jsFilter.dataset.index && element.dataset.type === jsFilter.dataset.type) : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.querySelector(`.js-filter[data-index="${elementToRender.dataset.index}"][data-type="${elementToRender.dataset.type}"]`).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
      // document.querySelector(`.js-filter[data-index="${element.dataset.index}"][data-type="${element.dataset.type}"]`).innerHTML = element.innerHTML
    });
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderAdditionalElements(html) {
    const elementSelectors = ['.active-facets'];
    elementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const elements = document.querySelectorAll(selector);
      [...elements].forEach((element) => {
        element.innerHTML = html.querySelector(selector).innerHTML;
      });
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');
    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');
    if (sourceElement && targetElement) target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    if (targetElementAccessibility && sourceElementAccessibility) target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const gteValue = formData.get('filter.v.price.gte');
    const lteValue = formData.get('filter.v.price.lte');
    const rangeMin = form.querySelector('input[name="min"]')?.min || 0;
    const rangeMax = form.querySelector('input[name="max"]')?.max || 0;
    const toRemove = ['min', 'max'];
    if (
      (gteValue === rangeMin && lteValue === rangeMax) || 
      (gteValue === '' && lteValue === '') ||
      (gteValue === rangeMin && lteValue === '') ||
      (gteValue === '' && lteValue === rangeMax)
    ) {
        toRemove.push('filter.v.price.gte', 'filter.v.price.lte');
    }
    toRemove.forEach(field => formData.delete(field));
    let params = new URLSearchParams(formData);
    const sortBy = params.get('sort_by');
    const priceGte = params.get('filter.v.price.gte');
    const priceLte = params.get('filter.v.price.lte');
    if (sortBy === 'price-ascending' || sortBy === 'price-descending' || (priceGte && priceGte.trim() !== '') || (priceLte && priceLte.trim() !== '')) {
      params.set('filter.p.m.custom.hide_price', '0');
    } else {
      params.delete('filter.p.m.custom.hide_price');
    }
    return params.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const filterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    const isMobile = event.target.closest('form').id === 'FacetFiltersFormDrawer';
    [...filterForms].forEach((form) => {
      if (!isMobile) {
        if (form.id === 'FacetFiltersForm') {
          if(this.createSearchParams(form) != '') forms.push(this.createSearchParams(form));
        }
      } else if (form.id === 'FacetFiltersFormDrawer') {
        if(this.createSearchParams(form) != '') forms.push(this.createSearchParams(form));
      }
    });
    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    let url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    if (url.indexOf('filter.v.price.gte') === -1 && url.indexOf('filter.v.price.lte') === -1) {
      url = url.replace('filter.p.m.custom.hide_price=0', '');
    }
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.rangeMin = this.querySelector('input[name="min"]');
    this.rangeMax = this.querySelector('input[name="max"]');
    this.inputMin = this.querySelector('input[name="filter.v.price.gte"]');
    this.inputMax = this.querySelector('input[name="filter.v.price.lte"]');
    // Input change
    this.inputMin.addEventListener('focus', this.inputMin.select);
    this.inputMax.addEventListener('focus', this.inputMax.select);
    this.inputMin.addEventListener('change', this.onInputMinChange.bind(this));
    this.inputMax.addEventListener('change', this.onInputMaxChange.bind(this));
    // Range change
    this.rangeMin.addEventListener('change', this.onRangeMinChange.bind(this));
    this.rangeMax.addEventListener('change', this.onRangeMaxChange.bind(this));
    this.rangeMin.addEventListener('input', this.onRangeMinInput.bind(this));
    this.rangeMax.addEventListener('input', this.onRangeMaxInput.bind(this));
  }

  onInputMinChange(event) {
    event.preventDefault();
    event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.inputMax.value || event.target.max) - 1), event.target.min);
    this.rangeMin.value = event.target.value;
    let percent = parseInt(this.rangeMin.value) / parseInt(this.rangeMin.max) * 100;
    this.rangeMin.parentElement.style.setProperty('--range-min', `${percent}%`);
    this.rangeMin.parentElement.classList.toggle('range-min', percent === 0);
  }

  onInputMaxChange(event) {
    event.preventDefault();
    event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.inputMin.value || event.target.min) + 1), event.target.max);
    this.rangeMax.value = event.target.value;
    let percent = parseInt(this.rangeMax.value) / parseInt(this.rangeMax.max) * 100;
    this.rangeMax.parentElement.style.setProperty('--range-max', `${percent}%`);
    this.rangeMax.parentElement.classList.toggle('range-max', percent === 100);
  }

  onRangeMinChange(event) {
    event.stopPropagation();
    this.inputMin.value = event.target.value;
    this.inputMin.dispatchEvent(new Event('change', { bubbles: true }));
  }

  onRangeMaxChange(event) {
    event.stopPropagation();
    this.inputMax.value = event.target.value;
    this.inputMax.dispatchEvent(new Event('change', { bubbles: true }));
  }

  onRangeMinInput(event) {
    event.target.value = Math.min(parseInt(event.target.value), parseInt(this.inputMax.value || event.target.max) - 1);
    let percent = parseInt(event.target.value) / parseInt(event.target.max) * 100;
    event.target.parentElement.style.setProperty('--range-min', `${percent}%`);
    event.target.parentElement.classList.toggle('range-min', percent === 0);
    this.inputMin.value = event.target.value;
  }

  onRangeMaxInput(event) {
    event.target.value = Math.max(parseInt(event.target.value), parseInt(this.inputMin.value || event.target.min) + 1);
    let percent = parseInt(event.target.value) / parseInt(event.target.max) * 100;
    event.target.parentElement.style.setProperty('--range-max', `${percent}%`);
    event.target.parentElement.classList.toggle('range-max', percent === 100);
    this.inputMax.value = event.target.value;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);